<app-toasts
  (closeToast)="closeToast($event)"
  [toastCollection]="toastCollection"
></app-toasts>
